import asBentoPage from 'common/bento/hoc/asBentoPage';
import SasuCreationEligibilityForm from 'features/Bento/flows/signup/components/SasuCreationEligibility';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

interface SasuCreationEligibilityProps {
  onSubmit: () => void;
}

const SasuCreationEligibility = asBentoPage<SasuCreationEligibilityProps>(
  ({ Layout, onPrev, onSubmit }) => (
    <Layout nav={<OBNavigation onPrev={onPrev} />}>
      <SasuCreationEligibilityForm onSubmit={onSubmit} />
    </Layout>
  ),
);

export default SasuCreationEligibility;
